<div class="canvas-chat-container">
  <div class="canvas-chat-header justify-content-between gap-2 px-4">
    <span
      class="canvas-citation-document-title"
      matTooltipPosition="below"
      [matTooltipClass]="['header-saved-search-item-theme']"
      matTooltip="{{ data?.sourceDocument?.document_title }}"
    >
      {{ data?.sourceDocument?.document_title }}
    </span>
    <div class="canvas-chat-action-container">
      <img
        src="../../../../../assets/icons/svg/close-square.svg"
        alt="Back"
        height="24"
        width="24"
        class="canvas-chat-action-button action-icon"
        (click)="closeDocumentDetails()"
        (keydown)="closeDocumentDetails()"
      />
    </div>
  </div>

  <div class="chats-list-container scrollbar-custom-scroll-style">
    <ng-container *ngIf="docuemntContent; else loading">
      <div class="document-details-content" [innerHtml]="docuemntContent"></div>
    </ng-container>
    <ng-template #loading>
      <div class="loading" *ngIf="isLoadingDocument; else failure">
        <mat-progress-spinner
          color="primary"
          mode="indeterminate"
          [diameter]="70"
        >
        </mat-progress-spinner>
        <span>Loading document...</span>
      </div>
      <ng-template #failure>
        <div class="failure">
          <img
            src="../../../../../assets/icons/svg/info-circle-error.svg"
            alt="Back"
            height="50"
            width="50"
          />
          <span>Failed to load document</span>
        </div>
      </ng-template>
    </ng-template>
  </div>
</div>
